<template lang="pug">
v-container.user-table(fluid)
  v-layout.mb-4(wrap)
    v-flex(
      xs12
      lg4)
      v-text-field(
        v-model="search"
        append-icon="search"
        label="搜尋關鍵字"
        single-line
        hide-details
        box)
  v-layout
    v-flex
      v-data-table(
        :headers="headers"
        :items="items"
        :search="search"
        :rows-per-page-items="[{'text': '全部', 'value': -1 }]"
        item-key="value")
        template(v-slot:items="props")
          td.text-xs-center
            v-btn(
              color="primary"
              flat
              small
              icon
              @click="openInfo(props.item)")
              v-icon visibility
          td.text-xs-center
            v-btn(
              color="warning"
              flat
              small
              icon
              :disabled="['super', 'admin', 'manager'].indexOf(role) === -1"
              @click="openEdit(props.item)")
              v-icon edit
          td.text-xs-center {{ props.item.displayName }}
          td.text-xs-right {{ props.item.number }}
          td.text-xs-center
            v-chip(
              v-for="job in props.item.jobs"
              :key="job"
              color="primary"
              text-color="white"
              disabled) {{ job }}
          td.text-xs-left {{ props.item.uid }}
          td.text-xs-left
            v-btn(
              color="warning"
              flat
              small
              icon
              :disabled="['super', 'admin', 'manager'].indexOf(role) === -1"
              @click="openReset(props.item)")
              v-icon redo
  v-dialog(
    v-model="info"
    max-width="500")
    v-card
      v-toolbar(
        dark
        card
        color="indigo")
        v-toolbar-title 會員資料明細
        v-spacer
        v-toolbar-items
          v-btn(
            icon
            dark
            @click="info = false")
            v-icon close
      v-card-text
        user-info(
          v-if="info"
          :user="edittingUser")
  v-dialog(
    v-model="edit"
    fullscreen)
    v-card
      v-toolbar(
        dark
        card
        color="indigo")
        v-toolbar-title 修改幹部權限
        v-spacer
        v-toolbar-items
          v-btn(
            icon
            dark
            @click="edit = false")
            v-icon close
      v-card-text
        permission-update-form(
          v-if="edit"
          :user="edittingUser"
          @update-succeed="update"
          @cancel="edit = false")
  v-dialog(
    v-model="reset"
    fullscreen)
    v-card
      v-toolbar(
        dark
        card
        color="indigo")
        v-toolbar-title 重設密碼
        v-spacer
        v-toolbar-items
          v-btn(
            icon
            dark
            @click="reset = false")
            v-icon close
      v-card-text
        password-reset-form(
          v-if="reset"
          :user="edittingUser"
          @update-succeed="update"
          @cancel="reset = false")
</template>

<script>
import { mapGetters } from "vuex";
import { db } from "@/firebase";
import PermissionUpdateForm from "@/components/forms/PermissionUpdateForm.vue";
import PasswordResetForm from "@/components/forms/PasswordResetForm.vue";
import UserInfo from "@/components/UserInfo.vue";

const headers = [
  { text: "查看", value: "look", align: "center" },
  { text: "修改權限", value: "edit", align: "center" },
  { text: "姓名", value: "displayName", align: "center" },
  { text: "編號", value: "number", align: "center" },
  { text: "職稱", value: "jobs", align: "center" },
  { text: "uid", value: "uid", align: "left" },
  { text: "重設密碼", value: "reset", align: "center" }
];

export default {
  name: "UserTable",
  components: {
    UserInfo,
    PermissionUpdateForm,
    PasswordResetForm
  },
  data() {
    return {
      search: "",
      info: false,
      edit: false,
      reset: false,
      headers,
      edittingUser: null,
      items: []
    };
  },
  computed: {
    ...mapGetters("auth", ["role"])
  },
  watch: {
    info(v) {
      if (v === false) this.edittingUser = null;
    },
    edit(v) {
      if (v === false) this.edittingUser = null;
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    openInfo(user) {
      this.edittingUser = user;
      this.info = true;
    },
    openEdit(user) {
      this.edittingUser = user;
      this.edit = true;
    },
    openReset(user) {
      this.edittingUser = user;
      this.reset = true;
    },
    async fetch() {
      const snap = await db
        .collection("users")
        .where("actived", "==", true)
        .get();
      const list = [];

      snap.forEach(doc => {
        // remove super
        if (doc.id !== "WDDX7TuE8gWy21vMoqIfSZ2wj4Y2") {
          const data = doc.data();
          data.uid = doc.id;
          list.push(data);
        }
      });

      this.items = list;
    },
    async update() {
      await this.fetch();
      this.edit = false;
      this.reset = false;
    }
  }
};
</script>
